<template>
  <div class="wrapper">
    <section>
      <input
        type="text"
        @keyup.enter="checkRima"
        placeholder="Word1..."
        class="input"
        ref="word1"
      />
      <input
        type="text"
        @keyup.enter="checkRima"
        placeholder="Word2..."
        class="input"
        ref="word2"
      />
      <input @click="checkRima" type="button" class="btn" value="Riman" />
      <p class="error" v-if="showError">{{ error }}</p>
      <div v-if="showWords" class="words">
        <p class="palabra">{{ palabraUno.palabra }}</p>
        <p id="space" class="palabra">{{ palabraDos.palabra }}</p>
      </div>
      <Entries class="goupInfo" name="riman" :value="riman" :parent="false" />
      <Entries name="tipoRima" :value="tipoRima" :parent="false" />
      <Entries class="goupInfo" name="plabraUno" :parent="true" />
      <div class="inner" v-for="(value, key) in palabraUno" :key="value">
        <Entries :name="key" :value="value" :parent="false" />
      </div>
      <Entries class="goupInfo" name="plabraDos" :parent="true" />
      <div class="inner" v-for="(value, key) in palabraDos" :key="value">
        <Entries :name="key" :value="value" :parent="false" />
      </div>
    </section>
  </div>
</template>

<script>
import Entries from "./Entries";
import * as riman from "riman";

export default {
  name: "Riman",
  components: {
    Entries,
  },
  data() {
    return {
      showError: false,
      showWords: false,
      error: "",
      riman: null,
      tipoRima: null, // consonante | asonante
      palabraUno: {
        palabra: null,
        rimaConsonante: null,
        rimaAsonante: null,
        longitudPalabra: null,
        numSilabas: null,
        silabas: null,
        acentuacion: null, // Aguda | Grave (Llana) | Esdrujula
        tonica: null,
        EsPrimeraVocal: null,
        EsUltimaVocal: null,
        EsPrimeraVocalTonica: null,
        hiato: null, // For example 'a-e' or 'i-a'
        diptongo: null, // For example ui or au
        triptongo: null, // For example uey
      },
      palabraDos: {
        palabra: null,
        rimaConsonante: null,
        rimaAsonante: null,
        longitudPalabra: null,
        numSilabas: null,
        silabas: null,
        acentuacion: null, // Aguda | Grave (Llana) | Esdrujula
        tonica: null,
        EsPrimeraVocal: null,
        EsUltimaVocal: null,
        EsPrimeraVocalTonica: null,
        hiato: null, // For example 'a-e' or 'i-a'
        diptongo: null, // For example ui or au
        triptongo: null, // For example uey
      },
    };
  },
  methods: {
    checkRima() {
      try {
        this.showWors = false;
        this.showError = false;
        const rima = riman.analyze(
          this.$refs.word1.value.trim(),
          this.$refs.word2.value.trim()
        );
        this.riman = rima.riman;
        this.tipoRima = rima.tipoRima;
        this.palabraUno = rima.palabraUno;
        this.palabraDos = rima.palabraDos;
        this.$refs.word1.value = "";
        this.$refs.word2.value = "";
        this.showWords = true;
      } catch (error) {
        this.error = error.toString().replace(/['"]+/g, "");
        this.showWords = false;
        this.showError = true;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
}
section {
  text-align: left;
}
.inner {
  margin-left: 2rem;
}
.goupInfo {
  margin-top: 2rem;
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgb(162, 175, 194);
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: rgb(162, 175, 194);
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: rgb(162, 175, 194);
}
:-moz-placeholder {
  /* Firefox 18- */
  color: rgb(162, 175, 194);
}

.input {
  font-weight: bold;
  width: 200px;
  margin-right: 10px;
  margin-top: 10px;
  height: 35px;
  padding: 6px 15px;
  border-radius: 5px;
  outline: none;
  border: none;
  background: #f6f7f9;
  color: #748194;
  font-size: 14px;
}

.input:focus {
  box-shadow: 0px 0px 8px 0px rgba(108, 136, 201, 0.4);
}

.btn {
  font-weight: bold;
  width: 130px;
  margin-left: 10px;
  margin-top: 10px;
  height: 45px;
  border-radius: 5px;
  outline: none;
  border: none;
  background: #6c88c9;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.btn:hover {
  background: #53699c;
}

.words {
  display: flex;
}

.palabra {
  padding: 1rem 2rem;
  background-color: white;
  border-radius: 5px;
  font-weight: bold;
  color: #385879;
  border: solid 2px #385879;
}

#space {
  margin-left: 10px;
}

.error {
  padding: 1.5rem 2rem;
  background-color: rgb(255, 202, 202);
  margin-right: 10px;
  border-radius: 5px;
  font-weight: bold;
  color: rgb(236, 65, 65);
  border: solid 2px rgb(255, 126, 126);
}

@media (max-width: 700px) {
  section {
    text-align: left;
    margin-left: 10px;
  }
}
</style>